import React, { FC } from 'react';
import { Button, CheckmarkIcon } from '@sweatpals/react-ui-kit';
import { useFollowToggle } from '@/modules/_core/hooks';
import { SxProps } from '@mui/system';

export const JoinButton: FC<{
	username: string;
	sx?: SxProps;
}> = ({ username, sx }) => {
	const { isFollowing, isLoading, onToggleFollow } = useFollowToggle({ username });

	return (
		<Button onClick={onToggleFollow} disabled={isLoading} sx={sx} loading={isLoading}>
			{isFollowing && <CheckmarkIcon width={18} height={18} />}
			Join community
		</Button>
	);
};
